<div *ngIf="metrics" class="lifestyle-wrapper">
	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lifestyle.exercise-status'">Excercise Status</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Exercise Status')">
							UPDATED: {{ chartType['Exercise Status'].attributeUpdatedDate }}
						</span>
					</div>
					<div class="col-md-3">
						<div class="vertical-center">
							<p
								*ngIf="chartType.hasOwnProperty('Exercise Status')"
								[style.color]="chartType['Exercise Status'].pointerColor">
								{{ chartType['Exercise Status'].attributeValue }}
							</p>
						</div>
					</div>
					<div class="col">
						<span *ngIf="chartType.hasOwnProperty('Exercise Status') !== true">
							Your lab results are not available
						</span>
						<p *ngIf="chartType.hasOwnProperty('Exercise Status')">
							{{ chartType['Exercise Status'].metricDescription }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="section-wrapper" *ngIf="movementScreen === false">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lifestyle.movement-screen'">Movement Screen</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Movement-Screen')">
							UPDATED: {{ chartType['Movement-Screen'].attributeUpdatedDate }}
						</span>
					</div>
					<div class="col-md-3"></div>
					<div class="col">
						<span *ngIf="chartType.hasOwnProperty('Movement-Screen') !== true">
							Your lab results are not available
						</span>
						<p *ngIf="chartType.hasOwnProperty('Movement-Screen')">
							{{ chartType['Movement-Screen'].metricDescription }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lifestyle.happiness-scale'">Happiness Scale</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Happiness Scale')">
							UPDATED: {{ chartType['Happiness Scale'].attributeUpdatedDate }}
						</span>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-4' : 'col-md-3'">
						<app-progress-bar
							class="Happiness-Scale"
							*ngIf="chartType.hasOwnProperty('Happiness Scale') && renderCharts === true"
							[chartData]="chartType['Happiness Scale']"></app-progress-bar>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-8' : 'col'">
						<span *ngIf="chartType.hasOwnProperty('Happiness Scale') !== true"
							>Your lab results are not available
						</span>
						<p *ngIf="chartType.hasOwnProperty('Happiness Scale')">
							{{ chartType['Happiness Scale'].metricDescription }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lifestyle.difficulty-sleeping'">
					Difficulty Sleeping
				</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Difficulty Sleeping')">
							UPDATED: {{ chartType['Difficulty Sleeping'].attributeUpdatedDate }}
						</span>
					</div>
					<div class="col-md-3">
						<div class="vertical-center">
							<p
								*ngIf="chartType.hasOwnProperty('Difficulty Sleeping')"
								[style.color]="chartType['Difficulty Sleeping'].pointerColor">
								{{ chartType['Difficulty Sleeping'].attributeValue }}
							</p>
						</div>
					</div>
					<div class="col">
						<span *ngIf="chartType.hasOwnProperty('Difficulty Sleeping') !== true">
							Your lab results are not available
						</span>
						<p *ngIf="chartType.hasOwnProperty('Difficulty Sleeping')">
							{{ chartType['Difficulty Sleeping'].metricDescription }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lifestyle.alcohol-consumption'">
					Alcohol Consumption
				</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Alcohol')">
							UPDATED: {{ chartType['Alcohol'].attributeUpdatedDate }}
						</span>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-4' : 'col-md-3'">
						<app-progress-bar
							class="Alcohol"
							*ngIf="chartType.hasOwnProperty('Alcohol') && renderCharts === true"
							[chartData]="chartType['Alcohol']"></app-progress-bar>
					</div>
					<div [className]="appUtil.isScreenSizeIpad() ? 'col-md-8' : 'col'">
						<span *ngIf="chartType.hasOwnProperty('Alcohol') !== true"> Your lab results are not available </span>
						<p *ngIf="chartType.hasOwnProperty('Alcohol')">{{ chartType['Alcohol'].metricDescription }}</p>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="section-wrapper">
		<div>
			<div class="section-block">
				<div class="section-block-header" [translate]="'wellness.lifestyle.tobacco-usage'">Tobacco Use</div>
				<div class="row section-block-content">
					<div class="col-md-12">
						<span class="last-update-on" *ngIf="chartType.hasOwnProperty('Tobacco')">
							UPDATED: {{ chartType['Tobacco'].attributeUpdatedDate }}
						</span>
					</div>
					<div class="col-md-3">
						<div class="vertical-center">
							<p *ngIf="chartType.hasOwnProperty('Tobacco')" [style.color]="chartType['Tobacco'].pointerColor">
								{{ chartType['Tobacco'].attributeValue }}
							</p>
						</div>
					</div>
					<div class="col">
						<span *ngIf="chartType.hasOwnProperty('Tobacco') !== true"> Your lab results are not available </span>
						<p *ngIf="chartType.hasOwnProperty('Tobacco')">{{ chartType['Tobacco'].metricDescription }}</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>
